export default function controlTypeDirective() {
  return {
    template: require('./control-type.html'),
    restrict: 'E',
    controller: 'ControlTypeController',
    controllerAs: 'controlTypeVM',
    bindToController: true,
    replace: true,
    scope: {
      controlType: '=',
      showAssign: '<',
      showEdit: '<',
      showUnassign: '<',
      showDelete: '<',
      riskTypeControlTypeId: '<',
      tooltipAppendToSelector: '@',
      assetType: '<',
      riskType: '<',
    },
  };
}
